import { setContractDetailsData, resetContractDetailsData } from '../../../redux/contractDetailsDataSlice';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import MachinesConcernee from '../../machinesConcernee/machinesConcernee';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import React, { useCallback, useEffect, useState } from 'react';
import ContractDetailsHeader from './contractDetailsHeader';
import { useDispatch, useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import PdfDocuments from '../../pdfDocuments';
import ContractMainData from './contractMainData';
import ContractPeriod from './contractPeriod';
import { useParams } from 'react-router-dom';
import { saveAs } from 'file-saver';
import axios from 'axios';

const ContractDetails = () => {

  const { id } = useParams();
  const dispatch = useDispatch();

  const [pdfId, setPdfId] = useState(null);
  const [openDeletePDF, setOpenDeletePDF] = useState(false);

  const [loading, setLoading] = useState(true);
  const [currentPeriod, setCurrentPeriod] = useState(0);
  const [selectedMachines, setSelectedMachines] = useState([]);
  const [openAddMachines, setOpenAddMachines] = useState(false);
  const [openRemoveMachine, setOpenRemoveMachine] = useState(false);
  const [allMachinesSelected, setAllMachinesSelected] = useState(false)
  const [addMachinesFilter, setAddMachinesFilter] = useState({
    selectedRegion: '',
    selectedSite: '',
    selectedPole: '',
    selectedMetier: '',
    selectedStatus: '',
    selectedType: '',
    selectedMark: '',
    debouncedSearch: '',
    selectedArchiveStatus: 'Unarchived'

  })

  const hasContractUpdatePermission = useHasPermission('contract_update');
  const contractDetailsData = useSelector((state) => state.ContractDetailsData);
  const machines = contractDetailsData?.contract_date?.[currentPeriod]?.contract_machine;

  const handleUpdateMachines = useCallback(async () => {
    const data = {
      machines: selectedMachines,
      allMachinesSelected,
      filters: addMachinesFilter,
    }
    try {
      const response = await axios.patch(`contract/updateContractMachine/${contractDetailsData?.contract_date[currentPeriod].id}`, data);
      if (response.status === 200 || response.status === 201) {
        dispatch(setSuccessfullModifyDialog({ open: true, type: "Modifier les machines du contrat" }));
        dispatch(setContractDetailsData({
          ...contractDetailsData,
          contract_date: contractDetailsData?.contract_date.map((periodData, index) =>
            index === currentPeriod
              ? {
                ...periodData,
                contract_machine: response.data.contract_machine || []
              }
              : periodData
          )
        }));
        setOpenAddMachines(false);
        setSelectedMachines([]);
        setAllMachinesSelected(false);
      }
    } catch (error) {
      console.error('Error updating machines:', error);
      CustomErrorLogger(error, "Update Machines Error in MachinesConcernee");
    }
  }, [contractDetailsData, currentPeriod, dispatch, allMachinesSelected, selectedMachines, addMachinesFilter]);

  const handleRemoveMachine = useCallback(async (machine_id) => {
    const response = await axios.delete(`contract/removeContractMachine/${contractDetailsData?.contract_date[currentPeriod].id}/${machine_id}`);
    if (response.status === 200 || response.status === 201) {
      dispatch(setContractDetailsData({
        ...contractDetailsData,
        contract_date: contractDetailsData?.contract_date.map((periodData, index) =>
          index === currentPeriod
            ? {
              ...periodData,
              contract_machine: periodData.contract_machine.filter((machine) => machine.machine.id !== machine_id)
            }
            : periodData
        )
      }));
      setOpenRemoveMachine(false)
    }
  }, [contractDetailsData, currentPeriod, dispatch]);

  const fetchContractDetails = useCallback(async () => {
    try {
      const response = await axios.get(`contract/${id}`);
      if ((response.status === 200 || response.status === 201) && response.data) {
        dispatch(setContractDetailsData(response.data));
        setLoading(false)
      }
    } catch (error) {
      setLoading(false);
      console.error('Error Fetching medical files:', error);
      CustomErrorLogger(error, "Fetch Contract Details Error in ContractDetails");
    }
  }, [id, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchContractDetails()
    return () => {
      dispatch(resetContractDetailsData());
    };
  }, [fetchContractDetails, id, dispatch]);

  const handleUploadDocuments = async (files) => {
    try {
      const formData = new FormData();
      Array.from(files).forEach(file => {
        if (file.type === "application/pdf") {
          formData.append('files', file);
        } else {
          console.error("Invalid file format");
        }
      });
      formData.append('contract_id', contractDetailsData.id); // assuming contractDetailsData has the id

      const response = await axios.post('contract-document', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200 || response.status === 201) {
        // Assuming the response.data contains the array of uploaded documents
        const uploadedDocuments = [...contractDetailsData.contract_document, ...response.data];
        dispatch(setContractDetailsData({
          ...contractDetailsData,
          contract_document: uploadedDocuments
        }));
      }

    } catch (error) {
      console.error('Error uploading documents:', error);
      CustomErrorLogger(error, 'Error uploading documents');
    }
  };

  const handleDawnloadAllDocument = async () => {
    try {
      const response = await axios.get(`contract-document/downloadAll/${contractDetailsData.id}`, { responseType: 'blob' });
      if (response.status === 200 || response.status === 201) {
        const filename = response.headers['content-disposition']
          ?.split('filename=')[1]
          ?.replace(/"/g, '')
          || `contract-${contractDetailsData.id}-documents.zip`;

        saveAs(new Blob([response.data]), filename);
      }
    } catch (error) {
      console.error('Error dawnloading document:', error);
      CustomErrorLogger(error, 'Error dawnloading document');
    }
  };

  const handleDawnloadDocument = async (doc) => {
    try {
      const response = await axios.get(`contract-document/${doc.id}`, { responseType: 'blob' });
      if (response.status === 200 || response.status === 201) {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        saveAs(blob, doc.name);
      }
    } catch (error) {
      console.error('Error dawnloading document:', error);
      CustomErrorLogger(error, 'Error dawnloading document');
    }
  };

  const handleRemoveAllDocument = async () => {
    try {
      const response = await axios.delete(`contract-document/deleteAll/${contractDetailsData.id}`);

      if (response.status === 200 || response.status === 201) {
        dispatch(setContractDetailsData({
          ...contractDetailsData,
          contract_document: []
        }));
        setOpenDeletePDF(false);
      }

    } catch (error) {
      console.error('Error deleting document:', error);
      CustomErrorLogger(error, 'Error deleting document');
    }
  };

  const handleRemoveDocument = async (id) => {
    try {
      const response = await axios.delete(`contract-document/${id}`);

      if (response.status === 200 || response.status === 201) {
        dispatch(setContractDetailsData({
          ...contractDetailsData,
          contract_document: contractDetailsData.contract_document.filter(doc => doc.id !== id)
        }));
        setOpenDeletePDF(false)
      }

    } catch (error) {
      console.error('Error deleting document:', error);
      CustomErrorLogger(error, 'Error deleting document');
    }
  };


  return (
    <Box>
      {loading ?
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '80vh',
          }}
        >
          <CircularProgress
            sx={{
              '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
            }}
          />
        </Box>
        :
        <Box>
          <ContractDetailsHeader />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '40px',
              width: '100%',
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '20px',
              margin: '30px 0px 30px 0px',
            }}>
            <ContractMainData />
            <PdfDocuments
              documents={contractDetailsData?.contract_document}
              hasUpdatePermission={hasContractUpdatePermission}
              handleUploadDocuments={handleUploadDocuments}
              handleDawnloadAllDocument={handleDawnloadAllDocument}
              handleDawnloadDocument={handleDawnloadDocument}
              handleRemoveAllDocument={handleRemoveAllDocument}
              handleRemoveDocument={handleRemoveDocument}
              openDeletePDF={openDeletePDF}
              setOpenDeletePDF={setOpenDeletePDF}
              pdfId={pdfId}
              setPdfId={setPdfId}
            />
            <ContractPeriod
              currentPeriod={currentPeriod}
              setCurrentPeriod={setCurrentPeriod}
            />
            <MachinesConcernee
              machines={machines}
              openAddMachines={openAddMachines}
              setOpenAddMachines={setOpenAddMachines}
              openRemoveMachine={openRemoveMachine}
              setOpenRemoveMachine={setOpenRemoveMachine}
              selectedMachines={selectedMachines}
              setSelectedMachines={setSelectedMachines}
              allMachinesSelected={allMachinesSelected}
              setAllMachinesSelected={setAllMachinesSelected}
              addMachinesFilter={addMachinesFilter}
              setAddMachinesFilter={setAddMachinesFilter}
              handleUpdateMachines={handleUpdateMachines}
              handleRemoveMachine={handleRemoveMachine}
              hasPermission={hasContractUpdatePermission}

            />
          </Box>
          <SuccessfullModifyDialog />
        </Box>
      }
    </Box>
  );
}

export default ContractDetails;